import { FormPage } from 'pageModules/FormPage';

export default FormPage;
